import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { useAuthStore } from './store/authStore';
import LoadingSpinner from './components/common/LoadingSpinner';

function App() {
  const { isAuthenticated, isLoading, checkAuth } = useAuthStore();

  useEffect(() => {
    // Check authentication status on app load
    if (isAuthenticated) {
      checkAuth();
    }
  }, []);

  // Show loading while checking auth
  if (isLoading && isAuthenticated) {
    return <LoadingSpinner fullScreen message="Loading..." />;
  }

  return <RouterProvider router={router} />;
}

export default App;
